import React from "react";
import { Stack, Modal, Icon, Box, CircularProgress, Grid } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";

const ItemsListV2 = ({
  items,
  itemsLoading,
  itemDetailed,
  closeDetailed,
  sxExtra = {},
}) => {
  const [scrolling, setScrolling] = React.useState(false);
  const scrollTimeout = React.useRef(null);

  const handleScroll = () => {
    setScrolling(true);
    clearTimeout(scrollTimeout.current);
    scrollTimeout.current = setTimeout(() => setScrolling(false), 800);
  };

  React.useEffect(() => () => clearTimeout(scrollTimeout.current), []);

  return (
    <Grid container>
      {itemDetailed ? (
        <Modal
          open={!!itemDetailed}
          slotProps={{
            root: {},
            backdrop: {
              sx: {
                backgroundColor: "rgba(0, 0, 0, 0.2)",
              },
            },
          }}
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              backgroundColor: "#fff",
              // minWidth: '80%',
              maxHeight: "80%",
              borderRadius: "20px",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
              "&:focus": {
                outline: "none",
              },
              ...sxExtra,
            }}
          >
            <Icon
              onClick={closeDetailed}
              sx={{
                "&:hover": {
                  cursor: "pointer",
                  backgroundColor: "#e3e3e3",
                  color: "#fff",
                },
                p: "5px",
                backgroundColor: "#eee",
                borderRadius: "50%",
                zIndex: 1,
                position: "absolute",
                top: "10px",
                right: "10px",
              }}
            >
              <ClearIcon />
            </Icon>
            <Box
              onScroll={handleScroll}
              sx={{
                overflowY: "auto",
                padding: "30px",
                flexGrow: 1,
                minHeight: 0,
                scrollbarWidth: "thin",
                scrollbarColor: scrolling
                  ? "rgba(0, 0, 0, 0.35) transparent"
                  : "transparent transparent",
                "&::-webkit-scrollbar": {
                  width: "8px",
                },
                "&::-webkit-scrollbar-track": {
                  background: "transparent",
                },
                "&::-webkit-scrollbar-thumb": {
                  backgroundColor: scrolling
                    ? "rgba(0, 0, 0, 0.35)"
                    : "transparent",
                  borderRadius: "4px",
                  transition: "background-color 0.3s",
                },
              }}
            >
              {itemDetailed}
            </Box>
          </Box>
        </Modal>
      ) : null}
      {itemsLoading ? (
        <Box
          sx={{
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress size={"30px"} aria-label="Loading…" />
        </Box>
      ) : (
        items
      )}
    </Grid>
  );
};

export default ItemsListV2;
